import request from '@/plugins/axios'

export default {
    //获取通用配置
    getGlobalSetting() {
        return request.get(`/Opencloud/GlobalSetting/Setting`);
    },
    //保存应用付费信息
    saveApplicationFeeInfo(postData) {
        return request.post(`/Opencloud/ApplicationFee/SaveApplicationFeeInfo`, postData);
    },

    //获取应用付费信息
    getApplicationFeeInfo(applicationId) {
        return request.get(`/Opencloud/ApplicationFee/ApplicationFeeInfo?applicationId=${applicationId}`);
    },

    /*
    * 获取应用收费设置
    * */
    getAppChargeSetInfo() {
        return request.get(`/Opencloud/Application/AppChargeSetInfo`);
    }
}